// Copyright (c) 2017 Deere & Company

import ReimbursementSummary from '../../reimbursement-summary/summary/components';
import allAccounts from './all-accounts';
import claims from './claims';
import details from './details';

export default {
    childRoutes: [
        allAccounts,
        claims,
        details
    ],
    component: ReimbursementSummary,
    name: 'REIMBURSEMENT_SUMMARY',
    path: 'reimbursement-summary'
};




// WEBPACK FOOTER //
// ./src/routes/reimbursement-summary/index.js